import angular from 'angular';
import { filter } from 'rxjs/operators';
import '../../layouts.module';
import template from './channel-alert.component.html';
import './channel-alert.component.scss';
import { REALTIME_EVENT } from '../../../core/services/realtime.service';
import { needsAttention } from '../../../core/helpers/channel.helper';

const POLL_INTERVAL_MS = 60000;

class ChannelAlertController {
  constructor(
    ChannelsApiService,
    RealtimeService,
    EventBusService,
    SessionService,
    $state,
    $interval
  ) {
    this.ChannelsApiService = ChannelsApiService;
    this.RealtimeService = RealtimeService;
    this.EventBusService = EventBusService;
    this.$state = $state;
    this.$interval = $interval;
    this.canReconnect = SessionService.hasPermission('channel.configure');
    this.offline = [];
  }

  $onInit() {
    this.refresh();
    this.RealtimeService.connect();
    this.subscription = this.EventBusService.on(REALTIME_EVENT)
      .pipe(filter((event) => event && event.type === 'channel.status'))
      .subscribe(() => this.refresh());
    this.poll = this.$interval(() => this.refresh(), POLL_INTERVAL_MS);
  }

  $onDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.poll) this.$interval.cancel(this.poll);
    this.RealtimeService.disconnect();
  }

  refresh() {
    return this.ChannelsApiService.list().then(
      (channels) => {
        this.offline = channels.filter(needsAttention);
      },
      () => null
    );
  }

  reconnect(channel) {
    if (!this.canReconnect) return null;
    return this.$state.go('app.numbers', { conectar: channel.id });
  }
}

ChannelAlertController.$inject = [
  'ChannelsApiService',
  'RealtimeService',
  'EventBusService',
  'SessionService',
  '$state',
  '$interval'
];

angular.module('app.layouts').component('cpChannelAlert', {
  controller: ChannelAlertController,
  controllerAs: 'vm',
  template
});
